module.exports = __webpack_public_path__ + "626d877041b5eea0ba753ea08ca2f17d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_placeholder.png
// module id = 954
// module chunks = 0